<template>
<v-layout row class="align-center layout pl-0 app--page-header">
    <div class="page-header-left">
        <v-breadcrumbs divider="-" :items="breadcrumbs">
            <template v-slot:item="props">
                <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']">
                    <h3>{{ props.item.text }}</h3>
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <template v-if="breadcrumbs.length == 0">
            <v-breadcrumbs>
                <v-breadcrumbs-item>
                    <h3>{{ routeName }}</h3>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </template>
    </div>
    <div v-if="configuration && activeName == 'OrderList'"><h4 class="red--text">Tỷ giá mua hộ: {{ configuration.Currency | currency }}</h4></div>
    <v-spacer></v-spacer>
    <div class="page-header-right pr-3">
        <v-btn class="mr-3" small v-if="$route.meta.exportButton && !options.invisibleExportButton" @click="exportAction">
            <v-icon>{{$route.meta.exportButtonIcon ? $route.meta.exportButtonIcon : 'fa-file-excel-o'}}</v-icon>  {{$route.meta.exportButtonText ? $route.meta.exportButtonText : 'Xuất file'}}
        </v-btn>
        <v-btn class="mr-3" small v-if="$route.meta.otherButton && !options.invisibleOtherButton" @click="otherAction">
            <v-icon>{{$route.meta.otherButtonIcon ? $route.meta.otherButtonIcon : 'far fa-save'}}</v-icon>  {{$route.meta.otherButtonText ? $route.meta.otherButtonText : 'Log'}}
        </v-btn>
        <v-btn class="mr-3" small v-if="$route.meta.saveButton && !options.invisibleSaveButton" @click="saveData" v-shortkey.once="['ctrl', 's']" @shortkey="saveData">
            <v-icon>{{$route.meta.saveButtonIcon ? $route.meta.saveButtonIcon : 'far fa-save'}}</v-icon>  {{$route.meta.saveButtonText ? $route.meta.saveButtonText : 'Lưu'}}
        </v-btn>
        <v-btn class="mr-3" small v-if="$route.meta.createButton && !options.invisibleCreateButton" @click="createData" v-shortkey.once="['alt', 'n']" @shortkey="createData">
            <v-icon>{{$route.meta.createButtonIcon ? $route.meta.createButtonIcon : 'fa-plus'}}</v-icon>  {{$route.meta.createButtonText ? $route.meta.createButtonText : 'Tạo mới'}}
        </v-btn>
        <v-btn class="mr-3" small v-if="$route.meta.refreshButton" @click="refreshData" v-shortkey.once="['f6']" @shortkey="refreshData">
            <v-icon class="text--secondary">fa-sync</v-icon>
        </v-btn>
    </div>
</v-layout>
</template>

<script>
import menu from "@/api/menu";
import paths from "@/router/paths";
import {
    mapState
} from "vuex";
import {
    buildBreadcrumb
} from "@/commons/utils";
export default {
     data() {
        return {
            options: {}
        }
     },
    computed: {
        ...mapState({
            configuration: state => state.configuration.selected
        }),
        routeName() {
            var title = this.$route.params.title ? this.$route.params.title : this.$route.meta.title;
            return title ? title : this.$route.name;
        },
        activeName() {
            return this.$route.name;
        },
        breadcrumbs: function () {
            let breadcrumbs = [];
            let routeName = this.$route.name;
            breadcrumbs = buildBreadcrumb(routeName, this.$route.path, this.$route.params.Pid, this.$route.params.title, menu, paths);
            return breadcrumbs;
        }
    },
    methods: {
        exportAction() {
            window.getApp.$emit('EXPORT_ACTION');
        },
        otherAction() {
            window.getApp.$emit('OTHER_ACTION');
        },
        saveData() {
            window.getApp.$emit('PRE_SAVE_DATA');
        },
        createData() {
          this.$root.$emit('REQUEST_CREATE_DATA');
        },
        refreshData() {
          this.$root.$emit('REQUEST_REFRESH_DATA');
        },
        changeOption(options) {
            this.options = options;
        }
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$on("REQUEST_ROOT_OPTION", this.changeOption);
    }
};
</script>
